// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableManagerPromotion_Component__3yi4G","ActionCell":"DataTableManagerPromotion_ActionCell__NSukm","Actions":"DataTableManagerPromotion_Actions__20h0H"};